import React, { Component } from "react";
import ReactDOM from "react-dom";
import * as _ from "lodash";
import { connect } from "react-redux";
import { Route, Switch, NavLink, Redirect } from "react-router-dom";
import { Base, Button } from "zina-dogi-react";
import * as oet from "../../oet/redux";
import {
    TrackerFilter,
    Steps,
    FandCForm,
    OETBasicInfo,
    TrackerTable,
    ServiceOrderTable,
    MenuImporters,
    SitesTable
} from "../../oet";
import { CommentsModal, PartialCancellationTable, SSOTIModal } from "../components";
import swal from "sweetalert";

const STATUS = [
    "logistics_oet", // 0
    "project", // 1
    "tcc", // 2
    "fandc", // 3
    "cpm", // 4
    "omc", // 5
    "closed", // 6
    "cancelled" // 7
];

export class RunDetail extends Component {
    constructor(props) {
        super(props);
        this.pc = React.createRef();
    }

    componentWillMount() {
        this.getComponentData();
    }

    componentWillUpdate(nextProps) {
        const { oetID, runID } = this.props;
        if (nextProps.oetID !== oetID || nextProps.runID !== runID) {
            this.getComponentData(nextProps.oetID, nextProps.runID);
        }
    }

    getComponentData = (oetID = this.props.oetID, runID = this.props.runID) => {
        const { oet, run, getDetails, history, getRunDetail } = this.props;
        const haveOet = !!(oet && oet.id);
        const haveRun = !!(run && run.id);
        const get_run = res => {
            if (!haveRun) {
                getRunDetail(runID, oetID);
            } else if (run.id !== runID) {
                getRunDetail(runID, oetID);
            }
        };
        if (oetID && runID) {
            if (!haveOet) {
                getDetails(oetID, history, runID).then(get_run);
            } else if (oet.id !== oetID) {
                getDetails(oetID, history, runID).then(get_run);
            }
        }
    };

    render() {
        const { oet, run, loading, status, extraProps, user } = this.props;
        let isFoC = false;
        if (run && run.oet_item && oet && oet.items) {
            const item = oet.items.find(item => parseInt(item.id, 10) === parseInt(run.oet_item, 10));
            isFoC = item ? item.paid_foc === "foc" : false;
        }
        if (status != null) {
            console.log(
                `%c ${status} ${STATUS[status]}`,
                "background: #00f; color: #fff; padding: 8px; border: 1px solid #000; border-left: 4px solid #000;"
            );
        }
        let cpo_breadcrumb = {};
        if (oet && oet.cpo_data) {
            cpo_breadcrumb = {
                name: `CPO ${oet.cpo_data.number}`,
                rel: `/detail/${oet.cpo_data.id}/`
            };
        }
        const base_op = {
            className: "run_detail",
            title: `${oet ? `OET #${oet.id_zfill}` : ""} - ${run ? `Run #${run.number}` : ""} ${
                isFoC ? "Free of Charge" : ""
            }`,
            breadcrumbs: [
                { name: "Home", rel: "/", icon: "home" },
                { ...cpo_breadcrumb },
                {
                    name: `OET #${oet ? oet.id_zfill : ""}`,
                    rel: oet ? `/tracker/${oet.id}/` : null
                },
                {
                    name: `Run #${run ? run.number : ""}`
                }
            ],
            extraProps,
            loading
        };
        const is_partially_cancel = run && status === 6;
        return (
            <div>
                <CommentsModal ref="comment_modal" onSend={this.updateStatus} />
                <SSOTIModal
                    ref="ssoti_modal"
                    getData={page => this.props.getSSOTIOnlyParent(oet.id, run.id, page, true)}
                    cancelled={true}
                />
                <Base {...base_op}>
                    {run && run.available_status_transitions && this.computeSteps(run.available_status_transitions)}
                    {run && (
                        <TrackerFilter
                            ref="basic"
                            oet={oet}
                            run={run}
                            user={user}
                            status={status}
                            onSubmit={this.onFilter}
                            syncQuantityContract={this.props.syncQuantityContract}
                            changeQuantityLimit={this.props.changeQuantityLimit}
                            startPRValidation={this.props.startPRValidation}
                            syncWbs={this.props.syncWbs}
                            syncVoa={this.props.syncVoa}
                            commentsModal={this.refs.comment_modal}
                        />
                    )}
                    {<FandCForm onSubmit={this.onFilter} oet={oet} run={run} status={status} />}
                    {run && this.computeTabs(this.props.match.url, status, is_partially_cancel, run.oet_item, run, oet)}
                </Base>
            </div>
        );
    }

    computeTabs = (url, status, is_partially_cancel, itemID = null, run, oet) => {
        url = url.replace(/\/$/, '');
        return (
        <div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row"
                }}
            >
                {is_partially_cancel && (
                    <React.Fragment>
                        <Button color="primary" onClick={this.onCancelPartial}>
                            Partial Cancellation/Amendment
                        </Button>
                        <span style={{ margin: "4px" }} />
                        <Button color="primary" onClick={() => this.refs.ssoti_modal.open()}>
                            Show Cancel/Amend SSOTI
                        </Button>
                    </React.Fragment>
                )}
                <span style={{ flex: "1 1 auto" }} />
                <Route
                    exact
                    path={`${url}/site`}
                    render={() => (
                        <Button color="secondary" onClick={this.refreshAll} style={{ marginRight: "8px" }}>
                            ↺ Refresh
                        </Button>
                    )}
                />
                <Route
                    exact
                    path={`${url}/siteserv`}
                    render={() => (
                        <Button color="secondary" onClick={this.refreshAll} style={{ marginRight: "8px" }}>
                            ↺ Refresh
                        </Button>
                    )}
                />
                {this.props.oet && this.props.run && (
                    <div>
                        <MenuImporters
                            runID={this.props.run.id}
                            oetID={this.props.oet.id}
                            run={this.props.run}
                            status={status}
                            oet={this.props.oet}
                        />
                    </div>
                )}
            </div>
            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <NavLink exact to={`${url}`} className="nav-link" activeClassName="active">
                        OET Basic Information
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink exact to={`${url}/table`} className="nav-link" activeClassName="active">
                        CPO Tracker
                    </NavLink>
                </li>
                {this.projectLinks(url, status, run.type_flow)}
                {is_partially_cancel && (
                    <li className="nav-item">
                        <NavLink exact to={`${url}/partially_cancel`} className="nav-link" activeClassName="active">
                            Partial Cancellation/Amendment
                        </NavLink>
                    </li>
                )}
            </ul>
            <div className="tabs">
                <Switch>
                    <Route
                        exact
                        path={`${url}`}
                        render={props => (
                            <OETBasicInfo
                                {...props}
                                onItemsChange={this.onItemsChange}
                                oet={this.props.oet}
                                status={status}
                                itemID={itemID}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={`${url}/table`}
                        render={props => (
                            <TrackerTable
                                {...props}
                                onItemsChange={this.onItemsChange}
                                oet={this.props.oet}
                                status={status}
                                itemID={itemID}
                            />
                        )}
                    />
                    {is_partially_cancel && (
                        <Route
                            exact
                            path={`${url}/partially_cancel`}
                            render={props => (
                                <PartialCancellationTable
                                    {...props}
                                    ref={this.pc}
                                    getData={(page, site_ids = null, material_type = null) =>
                                        this.props.getSSOTIOnlyParent(
                                            oet.id,
                                            run.id,
                                            page,
                                            false,
                                            site_ids,
                                            material_type
                                        )
                                    }
                                    cancelled={false}
                                    onSearchSsotItems={this.onSearchSsotItems}
                                    run={run}
                                    oet={oet}
                                />
                            )}
                        />
                    )}
                    {this.projectTabs(url, status, run.type_flow)}
                    <Redirect to={`${url}`} />
                </Switch>
            </div>
        </div>
        );
    };

    refreshAll = () => {
        const { oetID, runID, getRunDetail } = this.props;
        // getRunDetail fetches the run (including available_status_transitions for the Steps/Send forward buttons)
        // and internally dispatches getSiteOet(page 1) + getOetSSOTI(page 1), so a single call
        // is enough to refresh Site Creator, Service Order and the workflow steps simultaneously.
        return getRunDetail(runID, oetID);
    };

    projectLinks = (url, status, type_flow) => {
        url = url.replace(/\/$/, '');
        if (status >= 1) {
            return (
                <React.Fragment>
                    {type_flow !== "sode_bulk" && (
                        <li className="nav-item">
                            <NavLink exact to={`${url}/site`} className="nav-link" activeClassName="active">
                                Site Creator
                            </NavLink>
                        </li>
                    )}
                    <li className="nav-item">
                        <NavLink exact to={`${url}/siteserv`} className="nav-link" activeClassName="active">
                            Service Order
                        </NavLink>
                    </li>
                </React.Fragment>
            );
        }
    };

    projectTabs = (url, status, type_flow) => {
        url = url.replace(/\/$/, '');
        if (status >= 1) {
            return (
                <React.Fragment>
                    {type_flow !== "sode_bulk" && (
                        <Route
                            exact
                            path={`${url}/site`}
                            render={props => (
                                <SitesTable
                                    {...props}
                                    sites={this.props.oet ? this.props.oet.sites : null}
                                    status={status}
                                    loading={true}
                                    pagination={{
                                        ...this.props.site_pagination,
                                        changePage: page =>
                                            this.props.changeSitesPage(this.props.oet.id, this.props.run.id, page)
                                    }}
                                />
                            )}
                        />
                    )}
                    <Route
                        exact
                        path={`${url}/siteserv`}
                        render={props => (
                            <ServiceOrderTable
                                {...props}
                                type_flow={this.props.oet && this.props.oet.type_flow}
                                oet_ssoti={this.props.oet && this.props.oet.ssoti}
                                status={status}
                                loading={true}
                                pagination={{
                                    ...this.props.ssoti_pagination,
                                    changePage: page =>
                                        this.props.changeSsotiPage(this.props.oet.id, this.props.run.id, page)
                                }}
                            />
                        )}
                    />
                </React.Fragment>
            );
        }
    };

    getStepOps = step => {
        let errors = [];
        if (step && step.conditions_needed) {
            errors = Object.keys(step.conditions_needed).map(key => {
                let error = step.conditions_needed[key];
                if (error.error) {
                    error = error.error;
                }
                if (Array.isArray(error) && error.length === 1) {
                    error = error[0];
                }
                // Temporary this should be review with Cristian Trujillo later
                try {
                    return error.split("_").join(" ");
                } catch (err) {
                    let errors = Object.values(error).map(value => {
                        delete value["id"];
                        return Object.keys(value).map(k => {
                            return `${k.split("_").join(" ")} ${value[k].split("_").join(" ")}`;
                        });
                    });
                    return _.uniqWith(errors, _.isEqual);
                }
            });
        }
        const step_ops = {
            back: step.back,
            display: `Send to ${step.display}`,
            disabled: !step.can_change_status,
            onClick: () => this.openCommentsModalTo(step),
            errors
        };
        switch (step.slug) {
            case "cancelled": {
                return {
                    ...step_ops,
                    display: "Cancel",
                    style: { color: "red" }
                };
            }
            case "to_be_processed_in_sap": {
                return {
                    ...step_ops,
                    display: "Send to  be Processed in SAP"
                };
            }
            case "closed": {
                return {
                    ...step_ops,
                    style: { color: "red" }
                };
            }
            default:
                return step_ops;
        }
    };

    computeSteps = steps => {
        if (steps && steps.length > 0) {
            steps = steps.map(step => {
                return this.getStepOps(step);
            });
            return <Steps steps={steps} />;
        }
    };

    openCommentsModalTo = step => {
        const modal = this.refs.comment_modal;
        const { runID, user } = this.props;
        modal.toggle({
            requestData: {
                content_type: 21,
                status: step.slug,
                object_id: parseInt(runID),
                user,
                step
            },
            withOnSend: true,
            nextStep: step
        });
    };

    updateStatus = step => {
        const { updateStatus, runID } = this.props;
        updateStatus(
            runID,
            step.slug,
            error => {
                if (error.response) {
                    const status = error.response.status;
                    if (status === 400) {
                        swal({
                            title: "Warning ...",
                            text: `${error.response.data.status}`,
                            icon: "warning",
                            timer: 3000,
                            button: true
                        });
                    }
                }
            },
            run => this.refs.comment_modal.toggle()
        );
    };

    onFilter = ev => {
        this.save(ev);
    };

    save = data => {
        const { oet, run, status, history } = this.props;
        switch (status) {
            case 1: {
                if (data.form === "f&c") {
                    const { saveFandC } = this.props;
                    saveFandC(oet.id, data, history, run.id);
                } else {
                    const { saveSOCountAndVPOCount } = this.props;
                    saveSOCountAndVPOCount(run.id, data).then(run => {
                        swal({
                            title: "Successfully updated!",
                            text: `Run #${run.number}`,
                            icon: "success",
                            timer: 3000,
                            button: true
                        });
                    });
                }
                break;
            }
            case 2: {
                const { saveTCC } = this.props;
                const { for_offer_number_created_in_csp } = data;
                saveTCC(oet.id, for_offer_number_created_in_csp, history, run.id);
                break;
            }
            case 3: {
                const { saveFandC } = this.props;
                saveFandC(oet.id, data, history, run.id);
                break;
            }
            case 4: {
                const { saveCPM } = this.props;
                const { base_id, account_indicator } = data;
                saveCPM(oet.id, base_id, history, run.id, account_indicator);
                break;
            }
            case 5: {
                const { saveOMC } = this.props;
                const { pr_approved_date } = data;
                saveOMC(oet.id, pr_approved_date, history, run.id);
                break;
            }
            default:
                break;
        }
    };

    onCancelPartial = () => {
        if (this.pc.current) {
            const { idm } = this.pc.current.getSelectedRows();
            const showMesagge = result => {
                if (result) {
                    let wrapper = document.createElement("div");
                    ReactDOM.render(
                        <div>
                            To see it click here:{" "}
                            <Button
                                color="primary"
                                onClick={() => {
                                    document.location = `/run/${result.run.oet_id}/${result.run.id}/`;
                                }}
                            >
                                RUN #{result.run.number}
                            </Button>
                        </div>,
                        wrapper
                    );
                    let el = wrapper.firstChild;
                    swal({
                        title: "A new run has been created",
                        content: el,
                        button: true
                    });
                    this.pc.current.resetSelectedRows();
                    this.pc.current.updateData(1);
                }
            };
            if (idm && idm.length > 0) {
                const { runID } = this.props;
                swal({
                    title: "Partial Cancellation/Amendment",
                    text: `You have selected ${idm.length > 1 ? idm.length : "an"} item${
                        idm.length > 1 ? "s" : ""
                    } to be Canceled/Amend from the existing Run ID.
                    Are you sure to continue?. This operation is not reversible.`,
                    icon: "warning",
                    buttons: {
                        close: "Close",
                        partial_cancel: "Partially Cancel",
                        amend: "Amend"
                    }
                }).then(willCancel => {
                    switch (willCancel) {
                        case "partial_cancel":
                            this.props
                                .onCancelSsotItems(runID, idm, "partial_cancel", this.props.oetID)
                                .then(showMesagge);
                            break;
                        case "amend":
                            this.props.onCancelSsotItems(runID, idm, "amend", this.props.oetID).then(showMesagge);
                            break;
                        default:
                            break;
                    }
                });
            } else {
                swal({
                    title: "Partial Cancellation",
                    text: "You must select the items to cancel",
                    icon: "info",
                    timer: 3000,
                    button: true
                });
            }
        }
    };

    onSearchSsotItems = (items, filter_type = null) => {
        const { runID } = this.props;
        return oet.service.searchSsotItems(runID, items, filter_type);
    };

    getSSOTItems = (oet_id, run_id, page, cancelled) => {
        return oet.service.getSSOTIOET(oet_id, run_id, page, cancelled).then(result => result);
    };
}

const computeStatus = run => {
    if (run) {
        return run ? STATUS.indexOf(run.status) : null;
    }
};

const mapStateToProps = (store, ownProps) => ({
    user: store.auth.user.id,
    oet: store.oet.oetSelected,
    run: store.oet.runSelected,
    oetID: ownProps.match.params.oetID,
    runID: ownProps.match.params.runID,
    loading: store.oet.loading,
    site_pagination: store.oet.site_pagination,
    ssoti_pagination: store.oet.ssoti_pagination,
    status: computeStatus(store.oet.runSelected)
});

const mapDispatchToProps = dispatch => ({
    getDetails: (oetID, history, runID) => {
        return dispatch(oet.actions.getOetInDetail(oetID, history, runID));
    },
    getRunDetail: (runID, oetID) => {
        return dispatch(oet.actions.getRunDetail(runID, oetID));
    },
    onCancelSsotItems: (runID, ids, action, oetID) => {
        return dispatch(oet.actions.cancelSsotItems(runID, ids, action, oetID));
    },
    getSSOTList: (oetID, runID) => {
        dispatch(oet.actions.getOetSSOTI(oetID, runID));
    },
    updateStatus: (runID, status, onFail = () => {}, onSuccess = () => {}) => {
        dispatch(oet.actions.updateRun(runID, { status }, onFail, onSuccess));
    },
    saveSOCountAndVPOCount: (
        runID,
        { so_count, vpo_count, for_offer_number_created_in_csp },
        onFail = () => {},
        onSuccess = () => {}
    ) => {
        return dispatch(
            oet.actions.updateRun(runID, { so_count, vpo_count, for_offer_number_created_in_csp }, onFail, onSuccess)
        );
    },
    saveTCC: (oetID, foncic, history, runID) => {
        dispatch(oet.actions.updateTCC(oetID, foncic, history, runID));
    },
    saveCPM: (oetID, foncic, history, runID, account_indicator) => {
        dispatch(oet.actions.updateCPM(oetID, foncic, history, runID, null, account_indicator));
    },
    saveOMC: (oetID, pr_approved_date, history, runID) => {
        dispatch(oet.actions.updateOMC(oetID, pr_approved_date, history, runID));
    },
    saveFandC: (oetID, body, history, runID) => {
        dispatch(oet.actions.updateFandC(oetID, body, history, runID));
    },
    syncQuantityContract: (oetID, runID, fn) => {
        dispatch(oet.actions.syncQuantityContract(oetID, runID, fn));
    },
    changeQuantityLimit: (oet_id, runID, fn) => {
        dispatch(oet.actions.changeQuantityLimit(oet_id, runID, fn));
    },
    startPRValidation: (oetID, runID, pr_validation_id, fn) => {
        dispatch(oet.actions.startPRValidation(oetID, runID, pr_validation_id, fn));
    },
    syncWbs: (oetID, runID, fn) => {
        dispatch(oet.actions.syncWbs(oetID, runID, fn));
    },
    syncVoa: (oetID, runID, fn) => {
        dispatch(oet.actions.syncVoa(oetID, runID, fn));
    },
    changeSitesPage: (oetID, runID, page) => {
        dispatch(oet.actions.changeSitesPage(oetID, runID, page));
    },
    changeSsotiPage: (oetID, runID, page) => {
        dispatch(oet.actions.changeSsotiPage(oetID, runID, page));
    },
    getSSOTIOnlyParent: (oetID, runID, page, cancelled, site_ids = null, material_type = null) => {
        return dispatch(oet.actions.getSSOTIOnlyParent(oetID, runID, page, cancelled, site_ids, material_type));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(RunDetail);
